export default __webpack_public_path__ + "./images/mv.23da8826.png";